<sc-auth-page-wrapper
  mainTitle="Ingresá tu nueva contraseña"
  [authAction]="authAction">
  <form auth-page-wrapper-content [formGroup]="form" class="text-center">
    <sc-input
      #password
      autocomplete="off"
      formControlName="password"
      placeholder="Contraseña"
      label="Contraseña"
      [debounceTime]="400"
      required type="password">
    </sc-input>
    <sc-password-rules [value]="password.value"></sc-password-rules>
    <sc-auth-error-messages [error]="error"></sc-auth-error-messages>
    <sc-button
      type="primary"
      (onClick)="recoverPass()"
      [loading]="isLoading"
      [disabled]="isLoading"
      id="recover-password">
      Recuperar contraseña
    </sc-button>
  </form>
  <div auth-page-wrapper-footer>
    <sc-auth-actions class="footer-action" [authAction]="authAction"></sc-auth-actions>
    <sc-auth-legal-footer></sc-auth-legal-footer>
  </div>
</sc-auth-page-wrapper>
